export default __webpack_public_path__ + "static/media/bg_bottom.b4132eda.png";